import { IconChatUILogo } from 'components/Icons';
import { IconButton } from 'components/Input/IconButton';
import styled from 'styled-components';

export const StyledChatBubbleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  color: ${({ theme }) => theme.background.strong};
  bottom: ${({ theme }) => theme.spacing['xl']};
  right: ${({ theme }) => theme.spacing['xl']};
  z-index: ${({ theme }) => `${theme._ui.chatPanel.zIndex}`};
  width: ${({ theme }) => theme.spacing['6Xl']};
  height: ${({ theme }) => theme.spacing['6Xl']};
  background: ${({ theme }) => theme.background.strong};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  outline: ${({ theme }) => `${theme.border['sm']} solid ${theme.border.inverseTransparent}`};
  :hover {
    cursor: pointer;
    background: ${({ theme }) => theme.background.strongHover};
  }
}
`;

export const StyledChatUILogo = styled(IconChatUILogo)`
  width: ${({ theme }) => theme.spacing['3Xl']};
  height: ${({ theme }) => theme.spacing['3Xl']};
`;

export const Fab = styled(IconButton)`
  padding: 0;
  background: none;
  outline: none;
  :hover {
    background: none!important; // src/components/Input/IconButton/styles.tsx will override without
  }
  :focus {
    box-shadow: none;
    outline: none!important; // won't apply on webview without
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    width: 2.75rem;
    height: 2.75rem};
}
`;
